/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { TokenExtractorService } from '../services/token-extractor/token-extractor.service';
import { TokenValidatorService } from '../services/token-validator/token-validator.service';

@Injectable({
  providedIn: 'root',
})
export class TokenGuard {
  constructor(
    private readonly tokenExtractorService: TokenExtractorService,
    private readonly tokenValidatorService: TokenValidatorService,
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.tokenExtractorService.getCookieToken().pipe(
      map((sessionTokenFromCookie) => {
        if (sessionTokenFromCookie) {
          this.tokenValidatorService.setTokenToStore(sessionTokenFromCookie);
          this.tokenValidatorService.setUserToStore(sessionTokenFromCookie);
        }
        return true;
      }),
    );
  }
}
